import { browser } from '$app/environment';
import { readable, type Readable } from 'svelte/store';

export const BUSINESS_AGENT_MOBILE_MEDIA_QUERY = '(max-width: 1023px)';
export const BUSINESS_AGENT_MOBILE_BREAKPOINT_PX = 1024;

export type MobileViewportStore = Readable<boolean>;
export type MobileViewportValue = boolean;

export const getMobileViewportSnapshot = (): MobileViewportValue => {
    if (!browser) return false;
    return window.matchMedia(BUSINESS_AGENT_MOBILE_MEDIA_QUERY).matches;
};

export const isMobileViewport: MobileViewportStore = readable(false, set => {
    if (!browser) {
        set(false);
        return;
    }

    const mediaQueryList = window.matchMedia(BUSINESS_AGENT_MOBILE_MEDIA_QUERY);
    const update = () => set(mediaQueryList.matches);

    update();
    mediaQueryList.addEventListener('change', update);
    window.addEventListener('resize', update);

    return () => {
        mediaQueryList.removeEventListener('change', update);
        window.removeEventListener('resize', update);
    };
});
